import Box from "@mui/material/Box";
import GroupList from "../../organisms/groups";

const GroupPage = () => {
  return (
    <Box sx={{ mb: 4, background: "#F5F4F4", px: 3 }}>
      <GroupList />
    </Box>
  );
};

export default GroupPage;
